import { ActionTree } from 'vuex'
import { ISidebarState } from './types'

const actions: ActionTree<ISidebarState, any> = {
  toggleSidebar({ commit, getters }) {
    commit('setSidebarOpen', !getters['isSidebarOpen'])
  },

  closeSidebar({ commit }) {
    commit('setSidebarOpen', false)
  },

  toggleSettings({ commit, getters }) {
    commit('setSettingsPanelOpen', !getters['isSettingsPanelOpen'])
  },

  closeSettings({ commit }) {
    commit('setSettingsPanelOpen', false)
  },

  toggleWhatsNew({ commit, getters }) {
    commit('setWhatsNewPanelOpen', !getters['isWhatsNewPanelOpen'])
  },

  closeWhatsNew({ commit }) {
    commit('setWhatsNewPanelOpen', false)
  },

  toggleHelp({ commit, getters }) {
    commit('setHelpPanelOpen', !getters['isHelpPanelOpen'])
  },

  closeHelp({ commit }) {
    commit('setHelpPanelOpen', false)
  },
}

export default actions

